import { z } from 'zod';

import { SCHEMAS } from './base';

export const customerLoginSchema = z.object({
  name: SCHEMAS.customerName,
  phoneCode: SCHEMAS.customerPhoneCode,
  phoneNumber: SCHEMAS.customerPhoneNumber,
});

export type CustomerLoginData = z.infer<typeof customerLoginSchema>;
